// POR QUE ESTA FUNÇÃO EXISTE, e ela é pequena de propósito.
//
// ── O ACHADO #02 DO RELATÓRIO DE QA, 22/09/2026 ──────────────────────────────────────────
//
// "A publicação falha com 'O servidor recusou a publicação. Se você já finalizou este
//  quadrinho, ele não pode mais ser alterado.' O QUADRINHO NÃO ESTAVA FINALIZADO. O console
//  mostra permission-denied: Missing or insufficient permissions."
//
// A mensagem antiga era UM CHUTE, e o chute estava numa linha só: qualquer erro cujo texto
// contivesse "permission" virava "você provavelmente finalizou". Não era verdade, e o pior
// não é a frase errada — é que ela mandava a pessoa procurar defeito onde não havia.
//
// ── O QUE A INVESTIGAÇÃO DE 24/09 MEDIU, e ela desmente a causa que o relatório supôs ────
//
// O relatório levanta, como "causa provável", que a conta de estudante não tem vínculo com
// escola. Medido contra `firestore.rules`, isso NÃO procede:
//
//   allow create: if request.auth != null
//                 && request.resource.data.autor.id == request.auth.uid
//                 && request.resource.data.publicacao.estado in ['rascunho','publicado']
//                 && !('paginas' in ...) && !('conteudo' in ...)
//
// Não há uma palavra sobre escola, instituição, turma ou professor. O vínculo aparece em
// OUTRO lugar — em quem pode LER as páginas de um item que declara `instituicaoId` —, e
// nunca em quem pode publicar. Então desativar a opção com o texto "peça ao seu professor
// para te adicionar" poria na tela uma regra que o produto não tem.
//
// ── O QUE A FUNÇÃO FAZ ──────────────────────────────────────────────────────────────────
//
// Ela só afirma o que é sabido. `finalizado` é lido do servidor antes de publicar — aquele
// `get` já acontecia e o resultado era jogado fora. Com ele na mão, a única causa que a tela
// pode nomear com honestidade passa a ser nomeada, e as outras viram o que são: um pedido
// para contar o que aconteceu, com o console do lado.

/** Um quadrinho finalizado tranca o próprio autor — é a trava do T2.58, e a regra recusa. */
export function mensagemDaFalha(erro: unknown, finalizadoNoServidor: boolean): string {
  const texto = erro instanceof Error ? erro.message : String(erro ?? "");
  const ehPermissao = /permission|insufficient/i.test(texto);

  if (!ehPermissao) {
    return "Não deu para publicar agora. Tente de novo em instantes.";
  }

  // A ÚNICA CAUSA QUE A TELA SABE. Aqui a frase antiga estava certa — e só aqui.
  if (finalizadoNoServidor) {
    return (
      "Este quadrinho já foi marcado como pronto, e por isso não pode mais ser alterado — " +
      "nem por você. Se quiser publicar uma versão nova, exclua este e publique outro no lugar."
    );
  }

  // E AQUI A HONESTIDADE VALE MAIS QUE UM PALPITE. Dizer "talvez seja X" quando X é falso
  // manda a pessoa consertar o que não está quebrado; foi o que aconteceu com o QA.
  return (
    "O servidor recusou a publicação, e não foi por este quadrinho estar finalizado — " +
    "ele não está. Não é nada que você tenha feito errado. Tente de novo em instantes; " +
    "se continuar, avise a equipe do HQ-Lab pelo botão de feedback."
  );
}
